<ppl-accordion [title]="'Application Summary'" [isOpen]="true" *authorize="[pageId, tabId, 'Summary', 'section']">
@if (notifications.length > 0) {
<div class="notif-bar" [class.notif-bar-blocking]="blockingCount > 0" role="region" aria-label="Notifications">
    <i class="fa fa-bell" aria-hidden="true"></i>
    <span class="notif-bar-text">
        <strong>Notifications</strong>
        @if (blockingCount > 0) {
        <span class="notif-bar-sub">· Acknowledgement required</span>
        }
    </span>
    <button type="button" class="btn btn-primary notif-bar-btn" (click)="openNotificationDrawer()"
        aria-haspopup="dialog">View</button>
</div>
}
    <div class="tile-grid summary-tile-grid">

        @if (isDataLoaded) {
        @if (isParticipantFlow || (associationMap && associationMap['IR']) || isPA) {
        <div class="tile wide-card">
            <p class="summary-heading">Letters and Agreements</p>
            <div class="letters-list">
                @if (isParticipantFlow || (associationMap && associationMap['IR'])) {
                    <div class="letter-row">
                        <span class="letter-name">Welcome Letter</span>
                        <div class="button-container no-padding no-margin">
                            <button class="view-welcome-letter btn btn-info" (click)="viewWelcomeLetter()"
                                aria-label="View your Welcome Letter">View</button>
                            <button class="download-welcome-letter btn btn-primary" (click)="handleDownload()"
                                aria-label="Download your Welcome Letter">Download</button>
                        </div>
                    </div>
                    }
                @if (isPA && isPAOfferLetterDataLoaded) {
                <div class="letter-row">
                    <span class="letter-name">Offer Letter</span>
                    <div class="letter-status-container">
                        <span class="letter-status">{{noOfPWCompleted}} of {{totalOfferLetters}} Completed</span>
                    </div>
                </div>
                }
                @if (isPA && isProviderFlow && isDRAAcknowledged) {
                <div class="letter-row">
                    <span class="letter-name">Dispute Resolution Agreement</span>
                    <div class="button-container no-padding no-margin">
                        <button class="view-welcome-letter btn btn-info" (click)="viewDisputeResolutionAgreement()"
                            aria-label="View Dispute Resolution Agreement">View</button>
                        <button class="download-welcome-letter btn btn-primary" (click)="handleDRADownload()"
                            aria-label="Download Dispute Resolution Agreement">Download</button>
                    </div>
                </div>
            }
            </div>
        </div>
        }

        @for (appInfo of applicationInfoItems; track appInfo; let idx = $index ) {
        <div class="tile">
            <p class="summary-heading">{{appInfo.summaryItemDisplayName}}</p>
            <p class="count">{{appInfo.summaryItemValue}}</p>
        </div>
        }


        @if (summaryItems && summaryItems.length > 0) {
        <div class="tile" role="region" aria-label="Associations" (click)="navigateToAssociations()"
        (keydown)="handleLinkKeydown($event, 'associationsTab')">
            <p class="summary-heading">Associations</p>
            <div class="tile-container">
                @for (summaryItem of summaryItems; track summaryItem) {
                <div class="info-row">
                    <span class="label">{{summaryItem.summaryItemDisplayName}}</span>
                    <span class="value">{{summaryItem.summaryItemValue}}</span>
                </div>
                }
            </div>
        </div>
        }

        <!-- @for (auth of authorizationItems; track auth; let idx = $index ) {
        <div class="tile">
            <p class="summary-heading">{{auth.summaryItemDisplayName}}</p>
            <p class="count">{{auth.summaryItemValue}}</p>
        </div>
        } -->

        @if (isParticipantFlow && paSummaryData) {
            <div class="tile wide-card">
                <p class="summary-heading">PA Summary</p>
                <div class="auth-table-wrapper">
                    <div class="auth-grid">
                        <div class="pa-summary-grid-row auth-grid-header">
                            <span>PA Name</span>
                            <span>Training</span>
                            <span>Health Assessment</span>
                            <span>I-9</span>
                            <span>Timesheets Awaiting Approval</span>
                        </div>
                        @for (pa of paSummaryData; track $index) {
                        <div class="pa-summary-grid-row auth-grid-data">
                            <span class="truncate-cell" [title]="pa.paName">{{pa.paName}}</span>
                            <span class="icon-cell"><i class="fa" aria-hidden="true" [ngClass]="{'fa-check text-success': pa.isTrainComp === true, 'fa-exclamation warning-text': pa.isTrainComp !== true}"></i></span>
                            <span class="icon-cell"><i class="fa" aria-hidden="true" [ngClass]="{'fa-check text-success': pa.haStatus === 'COMPLETED', 'fa-exclamation warning-text': pa.haStatus !== 'COMPLETED'}"></i><span *ngIf="pa.haVendor">&nbsp;{{pa.haVendor}}</span></span>
                            <span class="icon-cell"><i class="fa" aria-hidden="true" [ngClass]="{'fa-check text-success': pa.isI9Comp === 'C', 'fa-exclamation warning-text': pa.isI9Comp !== 'C'}"></i></span>
                            <span class="icon-cell clickable-count" role="button" tabindex="0" (click)="navigateToTimesheets()" (keydown)="handleLinkKeydown($event, 'timesheetsTab')">{{pa.acCount}}</span>
                        </div>
                        }
                    </div>
                </div>
            </div>
            }

        @if (!isPA && isWeeklyUtilizationSummaryPresent) {
            <div
            [ngClass]="
              weeklyUtilizationData && weeklyUtilizationData.length > 0
                ? 'tile wide-card util-auth-tile'
                : 'tile'
            " role="button" tabindex="0" (click)="navigateToAuth()" (keydown)="handleLinkKeydown($event, 'authTab')"
          >
            <p class="summary-heading">Current Week's Utilization and Upcoming Authorizations</p>
            <ng-container *ngIf="isSameMco; else showDifferentMcoTemplate">
                @if (weeklyUtilizationData && weeklyUtilizationData.length > 0) {
                <div class="auth-table-wrapper">
                    <div class="auth-grid">
                        <div class="auth-grid-row auth-grid-header">
                            <span>Authorization</span>
                            <span>Utilization</span>
                            <span>Remaining Time</span>
                            <span>Start Date</span>
                            <span>End Date</span>
                        </div>
                        <div class="auth-grid-row auth-grid-data"
                            *ngFor="let item of weeklyUtilizationData">
                            <div class="auth-desc">
                                    <div class="auth-mco">{{item.mcoName}} - {{item.serviceCode}}{{item.modifier ? ' · ' + item.modifier : ''}}{{item.description ? ' — ' + item.description : ''}} </div>
                                <!-- <div class="auth-svc">
                                    {{item.serviceCode}}{{item.modifier ? ' · ' + item.modifier : ''}}{{item.description ? ' — ' + item.description : ''}}
                                </div> -->
                            </div>
                            <span class="util-value">{{item.utilization !== null && item.utilization !== undefined ? item.utilization + '%' : '—'}}</span>
                            <span class="util-value">{{item.availableUnits || '—'}}</span>
                            <span class="util-value">{{item.startDate}}</span>
                            <span class="util-value">{{item.endDate}}</span>
                        </div>
                    </div>
                </div>
                } @else {
                <p class="none-message">None</p>
                }
            </ng-container>

            <ng-template #showDifferentMcoTemplate class="w-100">
                <div class="mb-5 alert alert-warning">
                    You have conflicting Authorizations and therefore your submission will be placed into PPL
                    review.
                </div>
            </ng-template>
        </div>
        }

        @if(isPA && !readOnly) {
        <div class="tile">
            <p class="summary-heading">Additional Demographics</p>
            <div class="button-container no-padding no-margin">
                @if (!this.filledInfo?.isWotcCertified) {
                <button class="download-welcome-letter btn btn-primary" (click)="openAdditionalDemographicsPopup()"
                    aria-label="Update now">Update
                    Now</button>
                } @else {
                <p class="count completed-count">Completed</p>
                }
            </div>
        </div>
        }
        @if(isPA && !readOnly) {
        <div class="tile">
            <p class="summary-heading">Monthly Hours Summary</p>
            <div class="button-container no-padding no-margin">
                <button class="download-welcome-letter btn btn-primary" (click)="openPbiReportPopup()"
                    aria-label="Update now">Generate Summary</button>

            </div>
        </div>
        }

        @if (isPA) {
        <div class="tile flex-dollars" role="region" aria-label="Flex Dollars">
            <p class="summary-heading">Flex Dollars</p>
            <div class="tile-container flex-dollars-rows">
                <div class="info-row flex-dollars-row">
                    <span class="label">Total Spent</span>
                    <span class="value flex-dollars-amount">{{ flexDollarData.totalSpent | currency }}</span>
                </div>
                <div class="info-row flex-dollars-row">
                    <span class="label">Available Balance</span>
                    <span class="value flex-dollars-amount">{{ flexDollarData.availableBalance | currency }}</span>
                </div>
            </div>
            <a class="highlight flex-dollars-link" [href]="flexDollarData.portalUrl" target="_blank" rel="noopener"
                aria-label="Go to Flex Dollar website (opens in a new tab)">leadingedge.wealthcareportal.com</a>
        </div>
        }

        @if (isPA && timeOffUtilizationData) {
            <div class="tile wide-card">
                <p class="summary-heading">Time Off Utilization</p>
                <div class="tile-container">
                  <div *ngFor="let item of timeOffUtilizationData | keyvalue" class="timeoff-section">
                    <div class="section-title">
                        {{ timeOffLabels[item.key] || (item.key | uppercase) }}
                    </div>
                    <div class="info-row">
                      <span class="label">Available</span>
                      <span class="value">{{ item.value.available }}</span>
                    </div>
                    <div class="info-row">
                      <span class="label">Utilized</span>
                      <span class="value">{{ item.value.utilized }}</span>
                    </div>
                    <div class="info-row" *ngIf="item.key === 'pto'">
                        <span class="label">Total Balance</span>
                        <span class="value">{{ item.value.total }}</span>
                    </div>
                  </div>
                </div>
              </div>
        }

        @if (isPA) {
        <div class="tile wide-card">
            <p class="summary-heading" role="button" tabindex="0"
                (keydown)="handleLinkKeydown($event, 'timesheetsTab')"
                aria-label="Pended/Denied Timesheets in the last 30 days">
                Pended/Denied Timesheets – Last 30 Days
            </p>
            <div class="auth-table-wrapper">
                <div class="auth-grid">
                    <div class="pended-denied-grid-row auth-grid-header">
                        <span>Consumer Name</span>
                        <span>Service Period</span>
                        <span>Status</span>
                        <span>Reason Code</span>
                    </div>
                    @for (row of paTSViewData; track $index) {
                    <div class="pended-denied-grid-row auth-grid-data clickable-count" role="button" tabindex="0"
                        (click)="navigateToPendedTimesheetsWithRow(row)"
                        (keydown)="handleLinkKeydown($event, 'timesheetsTab')"
                        [attr.aria-label]="row.consumerName + ' ' + row.serviceStartDate + ' to ' + row.serviceEndDate + ' ' + row.statusDescription">
                        <span class="truncate-cell" [title]="row.consumerName">{{row.consumerName}}</span>
                        <span>{{row.serviceStartDate}} – {{row.serviceEndDate}}</span>
                        <span>{{row.statusDescription}}</span>
                        <span class="truncate-cell" [title]="row.reasonCode">{{row.reasonCode}}</span>
                    </div>
                    }
                    @if (paTSViewData.length === 0) {
                    <div class="pended-denied-grid-row">
                        <span style="grid-column: 1 / -1; color: #6c757d;">No data found</span>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        @if (isProviderFlow && !readOnly) {
        @if(healthAssessments) {
        <div class="tile">
            <p class="summary-heading">Health Assessment Progress</p>
            @if ((healthAssessmentDaysRemaining !== null && healthAssessmentDaysRemaining <= 30 && healthAssessmentProgress === "Completed") || healthAssessmentProgress === "Compliant Expired") {
                @if(healthAssessmentDaysRemaining === 0 || healthAssessmentProgress === "Compliant Expired") {
                    <p class="expired-info">Expired</p>
                }
                @else {
                    <p class="expiring-info">Expiring in {{healthAssessmentDaysRemaining}} days</p>
                }
            
            }
            @else {
            <p class="completed-count">{{healthAssessmentProgress}}</p>
            }
            @if(healthAssessmentProgress !== "Completed" || (healthAssessmentDaysRemaining !== null && healthAssessmentDaysRemaining <= 30 && healthAssessmentProgress === "Completed")) {
                <div class="button-container no-padding no-margin">
                    <a href="{{healthAssessmentScheduleLink}}" class="view-welcome-letter btn btn-info"
                        aria-label="Access your training" target="_blank">
                        Schedule
                    </a>
                </div>
            }
        </div>
        }
        <ng-container>
            <ppl-lead-detail-summary-training-tile [programCode]="program.program_code"
            [selectedProviderId]="selectedLead" />
        </ng-container>
        }


        }
    </div>


    @if (isPA) {
    <div class="fs-5 fw-bold fst-italic pt-2 pb-2" role="region"
        aria-label="Attention Personal Assistant.">
        Attention Personal Assistant:
        <ol class="mt-2">
            <li class="mb-2 nostyle">
                <p id="employment-list-label">Before PPL can verify your employment eligibility (E-Verify), the following is
                needed:</p>
                <ul aria-labelledby="employment-list-label">
                    <li>
                        Sign your Offer Letter. Please go to the Forms tab, then
                        <a class="highlight" tabindex="0" role="link" (click)="navigateToForms()"
                            (keydown)="handleLinkKeydown($event, 'offerLetters')"
                            aria-label="Sign your Offer Letter. Please go to the Forms tab, then Offer Letters and click on the View button. Offer Letters">
                            Offer Letters</a>, and click on the View button.
                    </li>
                    <li>Complete your I-9 under the <a class="highlight" tabindex="0" role="link"
                            (click)="navigateToForms()" (keydown)="handleLinkKeydown($event, 'formsTab')"
                            aria-label="Complete your I-9 under the Forms tab. Forms tab">
                            Forms tab</a>.
                    </li>
                    <li>
                        Upload your I-9 Documentation under Required Documents tab. Please click at the
                        <a class="highlight" href="https://www.uscis.gov/i-9-central/form-i-9-acceptable-documents" target="_blank"
                            rel="noopener" aria-label="Upload your I-9 Documentation under Required Documents tab. Required Documents tab">
                            link
                        </a> to look at supporting docs.
                    </li>
                </ul>
            </li>
        </ol>
    </div>
    }
</ppl-accordion>



<div class="filter-panel">

    <ng-template #pdfDialog let-cancel="cancel">
        <div class="" *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="true" [pdfConfig]="pdfConfig"
                [signature]="" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile" [signatureId]=""
                [isParticipantFlow]="isParticipantFlow" [selectedParticipantId]="selectedLead"
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #additionalDemographicsDialog let-cancel="cancel">
        <ppl-additional-demographics [id]="selectedLead" (onUpdate)="handlePopUpClose()"></ppl-additional-demographics>
    </ng-template>
</div>

@if (isNotificationDrawerOpen) {
<div class="notif-backdrop" (click)="closeNotificationDrawer()"></div>
<aside #notificationDrawer class="notif-drawer" role="dialog" aria-modal="true" aria-labelledby="notifDrawerTitle"
    tabindex="-1" (keydown.escape)="closeNotificationDrawer()">
    <div class="notif-drawer-header">
        <h2 id="notifDrawerTitle">Notifications</h2>
        @if (blockingCount === 0) {
        <button type="button" class="btn btn-info notif-close" aria-label="Close notifications"
            (click)="closeNotificationDrawer()"><i class="fa fa-close" aria-hidden="true"></i></button>
        } @else {
        <span class="notif-lock-hint">Acknowledge required items to continue</span>
        }
    </div>
    <div class="notif-drawer-body">

        @if (hasDRA) {
        <section class="notif-section notif-critical" aria-label="Dispute Resolution Agreement">
            <h3>Dispute Resolution Agreement</h3>
            @for (item of disputeResolutionAgreementData; track $index) {
            <div [innerHTML]="item.alertMsg"></div>
            }
            @if (disputeResolutionAgreementData[0].isAckNeeded) {
            <button type="button" class="btn btn-primary notif-ack" [disabled]="isAcknowledging"
                (click)="acknowledgeDisputeResolutionAgreement()">Acknowledge</button>
            }
        </section>
        }

        @if (hasPAA) {
        <section class="notif-section notif-critical" aria-label="PA Agreement Form">
            <h3>PA Agreement Form</h3>
            @for (item of paAgreementFormData; track $index) {
            <div [innerHTML]="item.alertMsg"></div>
            }
            @if (paAgreementFormData[0].isAckNeeded) {
            <button type="button" class="btn btn-primary notif-ack" [disabled]="isAcknowledging"
                (click)="acknowledgePAAgreementForm()">Acknowledge</button>
            }
        </section>
        }

        @if (hasActionNeeded) {
        <section class="notif-section notif-warning" aria-label="Action Needed">
        <ol class="notif-ol">
            @if (retirementDocsAvailable && isPA) {
                <li class="retirement-docs-alert">
                    <h4 class="p-1 fw-bold">For 401(k) enrollment details and access to plan disclosure documents,
                        please check the
                        <a class="highlight" tabindex="0" role="link"
                           (click)="navigateToTaxDocumentsTab()"
                           (keydown.enter)="navigateToTaxDocumentsTab($event)"
                           (keydown.space)="navigateToTaxDocumentsTab($event)">Tax and 401 Documents</a> tab.</h4>
                </li>
            }
            <li *ngIf="offerLetterNeeded">
                <div class="p-1">
                    <h4 class="fw-bold">Please Sign Your Updated Wage Notice</h4>
                    <p>Changes have been made to the Wage Notice you signed when you registered with PPL.</p>
                    <p class="mt-2">These changes reflect your new wage parity benefits starting on May 1, 2026.</p>
                    <p class="mt-2">
                        Please review and sign the updated wage notice by clicking
                        <a class="highlight" tabindex="0" role="link"
                           (click)="navigateToFormsTab()"
                           (keydown)="handleLinkKeydown($event, 'formsTab')"> here</a>.
                    </p>
                </div>
            </li>
            <ng-container>
                <ng-container *ngIf="filledInfo?.pendingHealthAssessmentDate && filledInfo?.pendingHealthAssessmentDate?.includes('Sunday'); else checkPartial">
                    <li>
                        <div class="p-1">
                            <h4 class="fw-bold">Immediate Action Needed to Continue Working in CDPAP</h4>
                            <p>
                                According to our records, you have not taken any action to complete your CDPAP health assessment. Annual health assessments are a requirement to work in CDPAP and were due October 1, 2025 for personal assistants who transitioned to PPL in 2025.
                            </p>

                            <p class="mt-2">
                                <strong>You have missed your scheduled appointment and have not responded to our outreach attempts or taken efforts to reschedule over the past several weeks. You are now out of compliance and your CDPAP work eligibility will be suspended<span *ngIf="filledInfo?.pendingHealthAssessmentDate"> effective {{filledInfo?.pendingHealthAssessmentDate}}</span>.</strong> To avoid this, contact Mobile Health immediately at 646-680-0450 or go to
                                <a target="_blank" href="https://mobilehealth.com/ppl-medical-screenings-for-ppl-app">mobilehealth.com/ppl-medical-screenings-for-ppl-app</a> to schedule an appointment.
                            </p>
                        </div>
                    </li>
                </ng-container>

                <ng-template #checkPartial>
                    <ng-container *ngIf="filledInfo?.pendingHealthAssessmentDate && filledInfo?.pendingHealthAssessmentDate?.includes('Partial'); else checkIncomplete">
                        <li>
                            <div class="p-1">
                                <h4 class="fw-bold">Action Required: Complete Remaining Health Assessment Steps</h4>
                                <p>
                                    According to our records, you have started but not completed the required health assessment to remain eligible to work as a personal assistant in NY CDPAP. Health assessments were due October 1, 2025.
                                </p>

                                <p class="mt-2">
                                    Please take immediate action by contacting Mobile Health at 646-680-0450 or going to
                                    <a target="_blank" href="https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings">https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings</a>
                                    to complete all remaining items and avoid losing eligibility to work in the program.
                                </p>
                            </div>
                        </li>
                    </ng-container>
                </ng-template>

                <ng-template #checkIncomplete>
                    <ng-container *ngIf="filledInfo?.isPendingHealthAssessment">
                        <li>
                            <div class="p-1">
                                <h4 class="fw-bold">Action Required: Incomplete Health Assessment</h4>
                                <p>
                                    According to our records, you have not completed the required health assessment to remain eligible to work as a personal assistant in NY CDPAP. Health assessments were due October 1, 2025.
                                </p>

                                <p class="mt-2">
                                    Please take immediate action by contacting Mobile Health at 646-680-0450 or go to
                                    <a target="_blank" href="https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings">https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings</a>
                                    to complete your health assessment and avoid losing eligibility to work in the program.
                                </p>
                            </div>
                        </li>
                    </ng-container>
                </ng-template>
            </ng-container>

            <li *ngIf="filledInfo?.isOnHoldTraining">
                <div class="p-1">
                    <h4 class="fw-bold">Immediate Action Needed to Continue Working in CDPAP</h4>
                    <p>
                        You have not completed your required past-due training or responded to our repeated outreach attempts over the past several months. You are now out of compliance and your CDPAP work eligibility will be suspended effective {{ filledInfo?.onHoldStartDate }}. To avoid this, login to PPL&#64;Home or Time4Care to access training.
                    </p>
                    <p class="mt-2">For additional instructions, go to
                        <a target="_blank" href="https://cms-v8g1h2d3tswc0.cpln.app/lK5">https://cms-v8g1h2d3tswc0.cpln.app/lK5</a>.
                    </p>
                </div>
            </li>

            <li *ngIf="!filledInfo?.isOnHoldTraining && filledInfo?.isPendingNevvonTraining">
                <div class="p-1">
                    <h4 class="fw-bold">CDPAP Training Update</h4>
                    <p>
                        CDPAP personal assistants who started working with PPL in 2025 were required to complete five trainings in the Nevvon portal. PPL has reduced the number of required courses to focus on those most important to your role. Please log in to Time4Care or PPL&#64;Home to access your assigned trainings. If you have not yet completed the required trainings, please do so as soon as possible as you are no longer compliant with training requirements.
                    </p>
                    <p class="mt-2">For step‑by‑step instructions, click on this link:
                        <a target="_blank" href="https://cms-v8g1h2d3tswc0.cpln.app/lK5">Learn More About CDPAP Training</a>
                    </p>     
                </div>
            </li>

            <li *ngIf="!filledInfo?.isWotcCertified && isPA">
                <h4 class="p-1 fw-bold" >Please complete the additional demographic
                    questions, by
                    clicking on Update Now button on
                    Additional Demographics tile.</h4>
            </li>
            @if (showWGAlert) {
                <li>
                    @for (item of WGAlert; track $index) {
                        <div [innerHTML]="item.alertMsg"></div>
                      }
                </li>
            }
        </ol>
        </section>
        }

        @if (hasFraudAlert) {
        <section class="notif-section notif-critical" aria-label="Alert">
            @for (item of alertData; track $index) {
            <div [innerHTML]="item.alertMsg"></div>
            }
            <button type="button" class="btn btn-primary notif-ack" [disabled]="isAcknowledging"
                (click)="acknowledgeAlert('fraud')">Acknowledge</button>
        </section>
        }

        @if (hasMOUAlert) {
        <section class="notif-section notif-critical" aria-label="Alert">
            @for (item of MOUAlertData; track $index) {
            <div [ngClass]="{ 'reverse-dir': reverseText }" [innerHTML]="item.alertMsg"></div>
            }
            <button type="button" class="btn btn-primary notif-ack" [disabled]="isAcknowledging"
                (click)="acknowledgeAlert('MOU')">Acknowledge</button>
        </section>
        }

    </div>
</aside>
}

 <div class="filter-panel">
          <ng-template #pbiReportDialog let-cancel="cancel">
            <div>
              <ppl-dropdown-select
                    id="selectedAttribute"
                    placeholder="Select Lookback period"
                    [options]="pbiDropdownOptions"
                    [optionLabel]="'attribute_text'"
                    [optionValue]="'value'"
                    optionDisabled="disabled"
                    required="true"
                    aria-required="true"
                    arialabel="Select Attribute"
                    [attr.aria-label]="'Select Lookback'"
                    (selectionChange)="selectedPbiMonths = $event"
                    style="width: 100%; margin-bottom: 16px">
              </ppl-dropdown-select>
            </div>    
          </ng-template>
        </div>